import { Trans } from '@lingui/react';
import { NavStepper } from '../../../../../components/steppers/nav-stepper/NavStepper';
import { NavStepperStep } from '../../../../../components/steppers/nav-stepper/NavStepperStep';
import { useWarrantProgramSuspenseQuery } from '../../../WarrantProgram.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { WpStepMeeting } from '../steps/StepMeeting';
import { WpStepBoardStatement } from '../steps/StepBoardStatement';
import { WpStepAuditorStatement } from '../steps/StepAuditorStatement';
import { GqlBoardsStatementOption, GqlWarrantProgramKind } from '../../../../../graphql/base-types.graphql';

export const OptionsDecisionStepper = ({ warrantProgramId }: { warrantProgramId: string }) => {
  const companyId = useCompanyId();
  const {
    data: { warrantProgram, companySubscription, warrantProgramErrors: errors },
  } = useWarrantProgramSuspenseQuery({
    variables: { companyId, warrantProgramId, getWpErrors: true },
  });

  return (
    <NavStepper path={`*`} onStepSaved={() => null}>
      <NavStepperStep path="meeting" label={<Trans id="Meeting" />} index validatorStatus={errors!.meeting}>
        <WpStepMeeting
          warrantProgram={warrantProgram}
          snrAuth={warrantProgram.snrAuthorization}
          meeting={warrantProgram.meetingConcern?.meeting}
          hasActiveSubscription={companySubscription?.isActive ?? false}
        />
      </NavStepperStep>

      {warrantProgram.warrantKind !== GqlWarrantProgramKind.Employee && (
        <NavStepperStep
          path="boards-statement"
          label={<Trans id="Boards Statement" />}
          validatorStatus={errors!.boardsStatement}
        >
          <WpStepBoardStatement warrantProgram={warrantProgram} />
        </NavStepperStep>
      )}

      {warrantProgram.warrantKind !== GqlWarrantProgramKind.Employee &&
        warrantProgram.boardsStatementOption === GqlBoardsStatementOption.Produce && (
          <NavStepperStep
            path="auditor-statement"
            label={<Trans id="Auditor Statement" />}
            validatorStatus={errors!.auditorsStatement}
          >
            <WpStepAuditorStatement warrantProgram={warrantProgram} />
          </NavStepperStep>
        )}
    </NavStepper>
  );
};
